import { lessons } from "./lessons";
import { question_banks } from "./question-banks";
import { questions } from "./questions";
import { subjects } from "./subjects";

export const setup = {
  lessons,
  question_banks,
  questions,
  subjects,
};
